const TrackingDriver = {
  path: "",
  name: "",
  redirect: "/transfers-driver-tracking-list",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/transfers-driver-tracking-list",
      redirect: "/transfers-driver-tracking-list",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Transfers Tracking Driver List",
      meta: {
        requiresAuth: true,
        activeUrl: "/transfers-driver-tracking-list",
        parent: "/transfers-driver-tracking-list",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/trackingDriver"),
          meta: {
            requiresAuth: true,
            activeUrl: "/transfers-driver-tracking-list",
            parent: "/transfers-driver-tracking-list",

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Transfer Tracking Driver Detail",
          component: () => import("@/views/pages/trackingDriver/detail"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/transfers-driver-tracking-list",
            parent: "/transfers-driver-tracking-list",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default TrackingDriver;
